import {useEffect, useState} from "react";
import DisplayMenu from "./DisplayMenu";
import Map from "./Map";
import MobileFilters from "./MobileFilters";
import TabletFilters from "./TabletFilters";

interface MainProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  setCentersCheck: (val: boolean) => void;
  centersCheck: boolean;
  clear: boolean;
  setClear: (val: boolean) => void;
  clearClickable: boolean;
}

const Main: React.FC<MainProps> = ({
  displayValue,
  setDisplayValue,
  centersCheck,
  setCentersCheck,
  clear,
  setClear,
  clearClickable,
}) => {
  const [isFiltersOpen, setIsFiltersOpen] = useState<boolean>(false);

  useEffect(() => {
    if (isFiltersOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isFiltersOpen]);

  return (
    <section className="flex flex-col xl:flex-row xl:items-start xl:justify-start box-border xl:px-2">
      <div className="hidden xl:block">
        <DisplayMenu
          displayValue={displayValue}
          setDisplayValue={setDisplayValue}
          centersCheck={centersCheck}
          setCentersCheck={setCentersCheck}
          clear={clear}
          setClear={setClear}
          clearClickable={clearClickable}
          showCentersCheckbox={true}
        />
      </div>
      <div className="xl:hidden">
        <div className="w-[95%] mx-auto ">
          <div className="md:hidden">
            <MobileFilters
              displayValue={displayValue}
              map={true}
              comparator={"none"}
            />
          </div>
          <div className="hidden md:block xl:hidden">
            <TabletFilters
              displayValue={displayValue}
              map={true}
              comparator={"none"}
            />
            <div className="hidden lg:flex xl:hidden my-4 gap-4">
              <div className="w-[345px]">
                <DisplayMenu
                  displayValue={displayValue}
                  setDisplayValue={setDisplayValue}
                  centersCheck={centersCheck}
                  setCentersCheck={setCentersCheck}
                  clear={clear}
                  setClear={setClear}
                  clearClickable={clearClickable}
                  showCentersCheckbox={true}
                />
              </div>
              <div className="w-full h-[75vh]">
                <Map
                  displayValue={displayValue}
                  centersCheck={centersCheck}
                  clear={clear}
                  rk={-1}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-wrap justify-start lg:hidden">
            <button
              onClick={() => setIsFiltersOpen(true)}
              className="my-4 flex flex-wrap items-center gap-2 px-4 py-2.5 border border-[#2A424BC9] rounded-full bg-[#E5DCDD]">
              Display
              <svg
                className="mt-0.5"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none">
                <path
                  d="M3.26953 1.32812C6.41372 0.957352 9.58726 0.957326 12.7314 1.32812C13.8024 1.45475 14.3267 2.78562 13.6436 3.67773L10.9355 7.21094C10.1248 8.26837 9.6827 9.58678 9.68262 10.9463V15.3906C9.68261 15.4945 9.65479 15.5964 9.60352 15.6846C9.55227 15.7725 9.47911 15.8433 9.39258 15.8896C9.30577 15.9361 9.20798 15.9567 9.11133 15.9482C9.01481 15.9398 8.92227 15.9027 8.84375 15.8418L6.53418 14.0547C6.46742 14.0029 6.41265 13.935 6.375 13.8564C6.33734 13.7779 6.31732 13.6908 6.31738 13.6025V10.9453C6.31735 9.58581 5.8752 8.26781 5.06543 7.20996L2.35742 3.67871C1.67338 2.78658 2.19698 1.45476 3.26953 1.32812ZM12.6143 2.44043C9.73921 2.10202 6.83912 2.08085 3.96094 2.37695L3.38477 2.44043C3.32852 2.4473 3.27517 2.47015 3.23047 2.50586C3.18588 2.54154 3.1509 2.58863 3.12988 2.64258C3.10889 2.6966 3.10247 2.75586 3.11035 2.81348C3.1183 2.87109 3.1409 2.9259 3.17578 2.97168V2.97266L5.88379 6.50488C6.84689 7.76143 7.37209 9.32939 7.37207 10.9463V13.3184L7.3916 13.333L8.54688 14.2275L8.62695 14.2891V10.9453C8.62714 9.32874 9.1533 7.76118 10.1162 6.50488L12.8242 2.97266V2.97168C12.8591 2.92591 12.8817 2.87107 12.8896 2.81348C12.8975 2.75587 12.8911 2.69659 12.8701 2.64258C12.8491 2.58864 12.8141 2.54154 12.7695 2.50586C12.7249 2.47018 12.6714 2.44732 12.6152 2.44043H12.6143Z"
                  fill="#2A424B"
                  stroke="white"
                  stroke-width="0.1"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className="lg:hidden xl:block w-screen sm:w-[95%] sm:mx-auto md:mt-4 xl:mt-0 xl:w-full h-[80vh] xl:min-h-[100vh] xl:flex-1">
        <Map
          displayValue={displayValue}
          centersCheck={centersCheck}
          clear={clear}
          rk={-1}
        />
      </div>
      <div
        className={`fixed inset-0 z-[1001] lg:hidden h-screen overflow-y-auto transition-transform duration-700 ease-in-out ${isFiltersOpen ? "translate-x-0" : "-translate-x-full"}`}>
        <DisplayMenu
          displayValue={displayValue}
          setCentersCheck={setCentersCheck}
          centersCheck={centersCheck}
          setDisplayValue={setDisplayValue}
          clear={clear}
          clearClickable={clearClickable}
          setClear={setClear}
          setIsFiltersOpen={() => setIsFiltersOpen(false)}
          showCentersCheckbox={true}
        />
      </div>
    </section>
  );
};

export default Main;
